import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Page } from '@app/components';
import { IframePage } from '@app/pages/IframePage';
import {
  LOYALTY,
  LOYALTY_LABEL,
  LOYALTY_ROOT,
  LOYALTY_ROOT_LABEL,
  SEGMENTS,
  SEGMENTS_LABEL,
  CARDS,
  CARDS_LABEL,
  RECOMMEND_APP,
  RECOMMEND_APP_LABEL,
  RECOMMEND_APP_PARTNERS,
  RECOMMEND_APP_PARTNERS_LABEL,
  RECOMMEND_SETTINGS,
  RECOMMEND_SETTINGS_LABEL,
} from '@app/routes/iframe-routes/constants';
import type { NNavigation } from '@app/types';

export const loyaltyPages: NNavigation.Main = [
  {
    key: LOYALTY_ROOT,
    icon: <FontAwesomeIcon icon={faCreditCard} />,
    label: LOYALTY_ROOT_LABEL,
    title: LOYALTY_ROOT_LABEL,
    'data-testid': LOYALTY_ROOT,
    id: LOYALTY_ROOT,
    path: '',
    issidebaritem: 'true',
    sidebarparentid: LOYALTY_ROOT,
    className: 'menu-item-with-children',
    children: [
      {
        key: SEGMENTS,
        label: SEGMENTS_LABEL,
        'data-testid': SEGMENTS,
        id: SEGMENTS,
        path: '/segments/*',
        title: SEGMENTS_LABEL,
        issidebaritem: 'true',
        sidebarparentid: SEGMENTS,
        element: (
          <Page disableBreadcrumbs hideBackButton>
            <IframePage key={SEGMENTS} />
          </Page>
        ),
      },
      {
        key: LOYALTY,
        label: LOYALTY_LABEL,
        'data-testid': LOYALTY,
        id: LOYALTY,
        path: '/loyalty/*',
        title: LOYALTY_LABEL,
        issidebaritem: 'true',
        sidebarparentid: LOYALTY,
        element: (
          <Page disableBreadcrumbs hideBackButton>
            <IframePage key={LOYALTY} />
          </Page>
        ),
      },
      {
        key: CARDS,
        label: CARDS_LABEL,
        'data-testid': CARDS,
        id: CARDS,
        path: '/cards',
        title: CARDS_LABEL,
        issidebaritem: 'true',
        sidebarparentid: CARDS,
        element: (
          <Page disableBreadcrumbs hideBackButton>
            <IframePage />
          </Page>
        ),
      },
      {
        key: RECOMMEND_APP,
        label: RECOMMEND_APP_LABEL,
        id: RECOMMEND_APP,
        path: '/recommend/offers/*',
        title: RECOMMEND_APP_LABEL,
        issidebaritem: 'true',
        sidebarparentid: RECOMMEND_APP,
        element: (
          <Page disableBreadcrumbs hideBackButton>
            <IframePage key={RECOMMEND_APP} />
          </Page>
        ),
      },
      {
        key: RECOMMEND_APP_PARTNERS,
        label: RECOMMEND_APP_PARTNERS_LABEL,
        id: RECOMMEND_APP_PARTNERS,
        path: '/recommend/b2b/*',
        title: RECOMMEND_APP_PARTNERS_LABEL,
        issidebaritem: 'true',
        sidebarparentid: RECOMMEND_APP_PARTNERS,
        element: (
          <Page disableBreadcrumbs hideBackButton>
            <IframePage key={RECOMMEND_APP_PARTNERS} />
          </Page>
        ),
      },
      {
        key: RECOMMEND_SETTINGS,
        label: RECOMMEND_SETTINGS_LABEL,
        id: RECOMMEND_SETTINGS,
        path: '/recommend/settings/*',
        title: RECOMMEND_SETTINGS_LABEL,
        issidebaritem: 'true',
        sidebarparentid: RECOMMEND_SETTINGS,
        element: (
          <Page disableBreadcrumbs hideBackButton>
            <IframePage key={RECOMMEND_SETTINGS} />
          </Page>
        ),
      },
    ],
  },
];
